import { render, staticRenderFns } from "./addPhoto.vue?vue&type=template&id=600f00b5&scoped=true"
import script from "./addPhoto.vue?vue&type=script&lang=js"
export * from "./addPhoto.vue?vue&type=script&lang=js"
import style0 from "./addPhoto.vue?vue&type=style&index=0&id=600f00b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600f00b5",
  null
  
)

export default component.exports